/* success.icon.svg.js */

"use strict";
module.exports = {
    icon: `    
            <svg viewBox="0 0 20 20" preserveAspectRatio="none">
                <path class="foreground-gl" d="M9.44,15.66l-4.63-3.8A1.36,1.36,0,0,1,6.54,9.75l2.46,2,4.23-5.44A1.36,1.36,0,1,1,15.39,8Z" transform="translate(-0.08 -0.05)"/><path class="foreground-gl" d="M10,19.86a9.9,9.9,0,1,1,9.9-9.9A9.91,9.91,0,0,1,10,19.86ZM10,1.44A8.52,8.52,0,1,0,18.5,10,8.53,8.53,0,0,0,10,1.44Z" transform="translate(-0.08 -0.05)"/>
            </svg>
         `,
};
